var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      staticStyle: { "pointer-events": "auto" },
      attrs: {
        title: _vm.formData.id ? "修改" : "新增",
        visible: _vm.dialogFormVisible,
        "close-on-click-modal": false,
        "modal-append-to-body": true,
        modal: false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.clearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: {
            model: _vm.formData,
            rules: _vm.rules,
            "label-width": "80px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "sdk名称", prop: "report_name" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "上报渠道名称" },
                model: {
                  value: _vm.formData.report_name,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "report_name", $$v)
                  },
                  expression: "formData.report_name"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { width: "100%" } },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", "align-items": "center" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: _vm.formData.reportListName,
                        "label-width": "10px"
                      }
                    },
                    [
                      _c("el-input", {
                        staticClass: "operationFrame-entity",
                        attrs: {
                          disabled: true,
                          clearable: "",
                          placeholder: "请输入列表名称"
                        },
                        model: {
                          value: _vm.formData.reportListName,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "reportListName", $$v)
                          },
                          expression: "formData.reportListName"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-button", {
                    staticClass: "delete-btn fix-btn",
                    attrs: {
                      size: "mini",
                      type: "primary",
                      circle: "",
                      icon: "el-icon-plus"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.addArrayData()
                      }
                    }
                  })
                ],
                1
              ),
              _vm._l(_vm.formData.reportData, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index + "k2",
                    staticClass: "flex-array-item",
                    staticStyle: { "flex-direction": "column" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "btn-type",
                            attrs: {
                              prop: "reportData." + index + ".reportKey",
                              "label-width": "10px"
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "operationFrame-entity",
                              attrs: {
                                disabled: true,
                                clearable: "",
                                placeholder: "请输入上报渠道名称"
                              },
                              model: {
                                value: item.reportKey,
                                callback: function($$v) {
                                  _vm.$set(item, "reportKey", $$v)
                                },
                                expression: "item.reportKey"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "btn-type",
                            attrs: {
                              prop: "reportData." + index + ".reportVal",
                              "label-width": "10px"
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "operationFrame-entity",
                              attrs: { placeholder: "此处可填默认值" },
                              model: {
                                value: item.reportVal,
                                callback: function($$v) {
                                  _vm.$set(item, "reportVal", $$v)
                                },
                                expression: "item.reportVal"
                              }
                            })
                          ],
                          1
                        ),
                        _c("el-button", {
                          staticClass: "delete-btn fix-btn",
                          attrs: {
                            size: "mini",
                            type: "danger",
                            circle: "",
                            icon: "el-icon-delete"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.removeItemContent(index)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticStyle: { "margin-left": "10px" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "select-type",
                            attrs: {
                              clearable: "",
                              filterable: "",
                              placeholder: "类型"
                            },
                            model: {
                              value: _vm.typeArrayValue,
                              callback: function($$v) {
                                _vm.typeArrayValue = $$v
                              },
                              expression: "typeArrayValue"
                            }
                          },
                          _vm._l(_vm.typeArrayList, function(item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value }
                            })
                          }),
                          1
                        ),
                        _c("el-button", {
                          staticClass: "delete-btn",
                          attrs: {
                            size: "mini",
                            type: "primary",
                            circle: "",
                            icon: "el-icon-plus"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.addArrayItemData(index)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._l(item.arrayData, function(m, idx) {
                      return _c(
                        "div",
                        {
                          key: idx + "k3",
                          staticClass: "flex-array-item",
                          staticStyle: { "align-items": "center" }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "btn-type",
                              attrs: {
                                prop:
                                  "reportData." +
                                  index +
                                  ".arrayData." +
                                  idx +
                                  ".key",
                                "label-width": "10px"
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "operationFrame-entity",
                                attrs: { clearable: "", placeholder: "请输入" },
                                model: {
                                  value: m.key,
                                  callback: function($$v) {
                                    _vm.$set(m, "key", $$v)
                                  },
                                  expression: "m.key"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "btn-type",
                              attrs: {
                                prop:
                                  "reportData." +
                                  index +
                                  ".arrayData." +
                                  idx +
                                  ".value",
                                "label-width": "10px"
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "operationFrame-entity",
                                attrs: {
                                  clearable: "",
                                  placeholder: "此处可填默认值"
                                },
                                model: {
                                  value: m.value,
                                  callback: function($$v) {
                                    _vm.$set(m, "value", $$v)
                                  },
                                  expression: "m.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c("el-button", {
                            staticClass: "delete-btn",
                            attrs: {
                              size: "mini",
                              type: "danger",
                              circle: "",
                              icon: "el-icon-delete"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.removeArrayItem(index, idx)
                              }
                            }
                          })
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              })
            ],
            2
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { round: "" },
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "warning", round: "" },
              on: {
                click: function($event) {
                  return _vm.clearData(false)
                }
              }
            },
            [_vm._v("重置")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", round: "", loading: _vm.reqLoading },
              on: {
                click: function($event) {
                  return _vm.dataFormSubmit("ruleForm")
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }